import React from 'react';
import { useTranslation } from 'i18n';
import {
  Container,
  Controls,
  Button,
  CheckButton,
  DeleteButton,
  Textarea,
  Name,
} from 'components/text-editor/components/controls/components/name-text-snippet-editor/components/name-editor/style';
import { ReactComponent as EditorIcon } from 'styles/icons/highlight.svg';
import { ReactComponent as DeleteIcon } from 'styles/icons/delete-icon.svg';
import { ReactComponent as CheckIcon } from 'styles/icons/check-icon-filled.svg';

interface EditorProps {
  name?: string;
  onSave: (name?: string) => void;
  onDelete: () => void;
  hideNameEditor: Function;
}

const defaultValues = {
  name: '',
};

export const NameEditor = ({
  onSave,
  onDelete,
  hideNameEditor,
  ...props
}: EditorProps) => {
  const { t } = useTranslation();
  const [name, setName] = React.useState<string | undefined>(props.name);

  React.useEffect(() => {
    return () => hideNameEditor();
  }, []);

  const textarea = useFocusElement();

  function onChange(event) {
    setName(event.target.value);
  }

  function onSaveHandler() {
    onSave(name);
  }

  return (
    <Container>
      <Controls>
        <DeleteButton disabled={!props.name} onClick={onDelete}>
          <DeleteIcon />
        </DeleteButton>
        <CheckButton disabled={!name} onClick={onSaveHandler}>
          <CheckIcon />
        </CheckButton>
        <Textarea
          ref={textarea}
          value={name}
          onChange={onChange}
          placeholder={t('Enter snippet name')}
          autoFocus
        />
      </Controls>
    </Container>
  );
};

NameEditor.defaultValues = defaultValues;

function useFocusElement() {
  const element = React.useRef<any>();

  React.useEffect(() => {
    setTimeout(() => element.current?.focus(), 500);
  }, [element]);

  return element;
}

interface DisplayProps {
  name?: string;
  showNameEditor: Function;
}

export const NameDisplay = ({ name, showNameEditor }: DisplayProps) => {
  if (name) {
    return (
      <Container>
        <Controls>
          <Button onMouseDown={showNameEditor}>
            <EditorIcon />
          </Button>
          <Name>{name}</Name>
        </Controls>
      </Container>
    );
  } else {
    return null;
  }
};
